import {
    IDataArray,
} from "../index"

export class SurveyUser implements IDataArray {
    public Pkid = 0;
    public SurveyId: number;
    public UserId: number;

    public GetById(): number {
        return this.Pkid;
    }
}